import React, { useEffect, useRef } from "react";
import "./Landing.css";
import { Flex, Image } from "@chakra-ui/react";

import Conversation from "./conversation";
import Prompts from "./Prompts";

const Landing = () => {
  const backgrounds = [
    ["tess.png", "tess2.png"],
    ["nan.png", "nan2.png"],
    ["nad.png", "nad2.png"],
  ];
  const backgroundInd = Math.floor(Math.random() * 3);
  const videoEl = useRef(null);

  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch((error) => {
        console.error("Error attempting to play", error);
      });
  };

  useEffect(() => {
    attemptPlay();
  }, []);

  return (
    <Flex flexDirection="column" w="100%" alignItems="center">
      {/* <MainHeader variant="landing" /> */}
      <Flex
        fontFamily="Garamond"
        flex="1"
        boxSizing="border-box"
        w="100%"
        alignItems="center"
        padding="32px"
        flexDirection={{ base: "column", md: "row" }}
        justifyContent={{ base: "space-between", md: "flex-start" }}
        backgroundImage={{
          base: backgrounds[backgroundInd][1],
          md: backgrounds[backgroundInd][0],
        }}
        backgroundSize="cover"
        backgroundPosition="center center"
      >
        <Flex position="relative" height="520px" justifyContent="center" order={{ base: 0, md: -1 }} ml={{ base: 0, md: "10%" }}>
          <Image src="/Nandina.png" alt="Raven Support Network mascot welcoming newcomers to Canada" h="100%" />
          <Conversation />
        </Flex>
      </Flex>
      {/* <Flex flexDirection="column" w="100%">
        <Box position="relative">
          <Divider variant="brand" />
          <AbsoluteCenter bg="white" px="4">
            <Icon as={GoDotFill} color="#8d77ab" />
          </AbsoluteCenter>
        </Box>
        <ReviewGroup />
      </Flex> */}
      <Prompts />
    </Flex>
  );
};

export default Landing;
